import PMGrading from "./pm-grading/PMGradingRefactored";

const PMGradingPage = () => {
  return <PMGrading />;
};

export default PMGradingPage;
